import { noop } from '@tanstack/react-query';
import { insightsCountQuery } from '@/features/insights/queries';
import { activeTasksCountQuery } from '@/features/tasks/queries';
import { artifactsCountQuery } from '@/features/artifacts/queries';
import { workspaceQuery } from '@/features/workspaces/queries';
import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { ChatProvider } from '@/features/chat/components/chat-provider';
import { MainPending } from '@/ui/components/main';

export const Route = createFileRoute('/_authed/project/$projectId/workspaces/$workspaceId')({
  component: RouteComponent,
  loader: async ({ context, params }) => {
    const scope = {
      organizationId: context.auth.user.organizationId,
      projectId: params.projectId,
      workspaceId: params.workspaceId,
    };
    context.queryClient
      .infiniteQuery(insightsCountQuery({ workspaceId: params.workspaceId }))
      .catch(noop);
    context.queryClient.infiniteQuery(activeTasksCountQuery(scope)).catch(noop);
    context.queryClient.infiniteQuery(artifactsCountQuery(scope)).catch(noop);
    const workspace = await context.queryClient.query({
      ...workspaceQuery(params.workspaceId),
      staleTime: 'static',
    });
    if (workspace.projectId !== params.projectId) throw notFound();
  },
  pendingComponent: MainPending,
});

function RouteComponent() {
  const { workspaceId } = Route.useParams();
  return (
    <ChatProvider key={workspaceId}>
      <Outlet />
    </ChatProvider>
  );
}
